exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3s0EcLzZiu5fOveHPa_P_q{font-weight:500;font-size:14px}.pMx0pJ6XdWlw-iALFGx4I{position:relative;display:flex;width:240px;margin-bottom:15px}.pMx0pJ6XdWlw-iALFGx4I:last-child{margin-bottom:0px}.pMx0pJ6XdWlw-iALFGx4I img{height:60px;width:60px;margin-right:10px}.pMx0pJ6XdWlw-iALFGx4I .tlUBAxQctpKF4praSwLq9{position:absolute;left:0px;top:0px}.pMx0pJ6XdWlw-iALFGx4I ._3XMCsb-y0Tr2aotp5pn9hg{display:flex;flex-direction:column;width:170px}.pMx0pJ6XdWlw-iALFGx4I ._2napJ__W_EVvLIzfqBxSiI,.pMx0pJ6XdWlw-iALFGx4I .r6sWsuDXuB3MiiwMhtGGe{line-height:20px}.pMx0pJ6XdWlw-iALFGx4I .r6sWsuDXuB3MiiwMhtGGe{font-size:13px;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"link": "_3s0EcLzZiu5fOveHPa_P_q",
	"milestone": "pMx0pJ6XdWlw-iALFGx4I",
	"locked": "tlUBAxQctpKF4praSwLq9",
	"info": "_3XMCsb-y0Tr2aotp5pn9hg",
	"title": "_2napJ__W_EVvLIzfqBxSiI",
	"subInfo": "r6sWsuDXuB3MiiwMhtGGe"
};